'use client';

import { useState } from 'react';
import { DEMO_ACCOUNTS } from '../../data/mock-data';

interface LoginPageProps {
  onLogin: () => void;
  onGoToSignup: () => void;
  onGoToKiosk: () => void;
}

export default function LoginPage({ onLogin, onGoToSignup, onGoToKiosk }: LoginPageProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // 데모용 로그인 시뮬레이션
    setTimeout(() => {
      if (
        (email === DEMO_ACCOUNTS.admin.email && password === DEMO_ACCOUNTS.admin.password) ||
        (email === DEMO_ACCOUNTS.user.email && password === DEMO_ACCOUNTS.user.password)
      ) {
        onLogin();
      } else {
        setError('이메일 또는 비밀번호가 올바르지 않습니다.');
      }
      setLoading(false);
    }, 500);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h1 className="text-center text-3xl font-extrabold text-gray-900">
            파레트 키오스크 관리자
          </h1>
          <p className="mt-2 text-center text-sm text-gray-600">
            관리자 계정으로 로그인하세요
          </p>
        </div>

        {/* 데모 계정 안내 */}
        <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
          <p className="text-sm text-blue-800">
            <strong>데모 계정:</strong><br />
            이메일: admin@example.com<br />
            비밀번호: demo1234
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleLogin}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email" className="sr-only">
                이메일
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="이메일 주소"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                비밀번호
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="비밀번호"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {error && (
            <div className="rounded-md bg-red-50 p-4">
              <p className="text-sm text-red-800">{error}</p>
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? '로그인 중...' : '로그인'}
            </button>
          </div>

          <div className="text-center">
            <button
              type="button"
              onClick={onGoToSignup}
              className="font-medium text-indigo-600 hover:text-indigo-500"
            >
              관리자 계정이 없으신가요? 회원가입
            </button>
          </div>
        </form>

        <div className="text-center">
          <button
            onClick={onGoToKiosk}
            className="text-sm text-gray-600 hover:text-gray-900"
          >
            ← 키오스크로 돌아가기
          </button>
        </div>
      </div>
    </div>
  );
}
